import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  /**
   * Extracts the unsubscribe token from the current URL query string.
   */
  public getTokenFromLocation(paramName: string = 'token'): string | null {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get(paramName);
      if (!token || !token.trim()) {
        return null;
      }
      return token;
    } catch {
      return null;
    }
  }
}


